import { forwardRef } from "react";
import { FieldMessage, FieldMessageDefaultElement, getValidationProps } from "./FieldMessage";
import { mergeProps } from "../../shared";
import { useFieldMessageProps } from "./FieldContext";
import { jsx as _jsx } from "react/jsx-runtime";
export function InnerErrorMessage(props) {
  const [{
    validationState,
    ...messageProps
  }, isInField] = useFieldMessageProps();
  const {
    isError
  } = getValidationProps(validationState);
  const {
    children,
    forwardedRef,
    ...rest
  } = mergeProps(props, messageProps);

  if (isInField && !isError) {
    return null;
  }

  return /*#__PURE__*/_jsx(FieldMessage, { ...rest,
    ref: forwardedRef,
    tone: "error",
    children: children
  });
}
InnerErrorMessage.defaultElement = FieldMessageDefaultElement;
export const ErrorMessage = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerErrorMessage, { ...props,
  forwardedRef: ref
}));